import { defineTranslationScope } from "@app/shared/i18n/translation-scope";

export const scope = defineTranslationScope("audit-universe-period");
